import React from 'react';
import EnergySavingsLeafOutlinedIcon from '@mui/icons-material/EnergySavingsLeafOutlined';
import { Label } from '../Label';
export const CO2Label = ({ kg }) => (React.createElement(Label, { icon: React.createElement(EnergySavingsLeafOutlinedIcon, { fontSize: "small" }), backgroundColor: "green100", textColor: "green700", letterSpacing: "normal", textTransform: "none", padding: "medium" },
    kg,
    " kg"));
